<style lang="scss" scoped>
.fixed-format-timestamp-group {
    position: relative;

    &:before {
        content: "";
        position: absolute;
        top: 10px;
        left: 0;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background-color: #f39225;
    }

    &:not(:last-child) {
        padding-bottom: 40px;

        @media screen and (min-width: 768px) {
            padding-bottom: 80px;
        }

        @media screen and (min-width: 1024px) {
            //padding-bottom: 120px;
        }
    }

    &:after {
        content: "";
        position: absolute;
        top: 10px;
        left: 6px;
        width: 1px;
        height: 100%;
        background-color: #f39225;
    }

    &:last-child {
        &:after {
            height: calc(100% + 80px);

            @media screen and (min-width: 1650px) {
                height: calc(100% + 120px);
            }
        }
    }
}

.fixed-format-entry {
    width: 100%;
    max-width: 488px;
}

.fixed-format-entry-row {
    gap: 40px;
    padding-left: 40px;

    @media screen and (min-width: 768px) {
        padding-left: 80px;
        gap: 80px;
    }

    @media screen and (min-width: 1024px) {
        //gap: 120px;
    }
}

.timepoint-wrapper {
    position: relative;
}

.timestamp {
    color: #172340;
    font-size: 20px;
    font-weight: 300;
    padding-left: 40px;

    @media screen and (min-width: 768px) {
        font-size: 24px;
        min-height: 36px;
        padding-left: 80px;
    }
}
.fixed-entry {
    position: relative;

    img {
        width: 100%;
        height: 180px;
        object-fit: cover;
        font-family: "object-fit: cover;";
        border-radius: 4px;

        @media screen and (min-width: 768px) {
            border-radius: 0;
            height: 273px;
        }
    }

    h4 {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 12px;

        @media screen and (min-width: 768px) {
            font-size: 24px;
            font-weight: 600;
            line-height: 34px;
        }
    }

    .content,
    p {
        color: #172340;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;

        @media screen and (min-width: 768px) {
            font-size: 16px;
            font-weight: 300;
            line-height: 1.5;
        }
    }

    ::v-deep p + p {
        margin-top: 16px;
    }
}

a {
    text-decoration: none;
    color: #172340;
}
</style>

<template>
    <div class="container position-relative" ref="fixedcontainer">
        <h3 class="mb-24 mb-sm-80">
            {{ activity.acf.content.fixed_format.title }}
        </h3>

        <div
            v-if="activity.acf.content.fixed_format.time_table"
            class="fixed-format-row"
        >
            <div
                class="fixed-format-timestamp-group"
                v-for="(entryGroup, index) in groupedFlatFormatArray"
            >
                <span class="timestamp d-inline-block mb-16 mb-md-40">{{
                    entryGroup.timestamp
                }}</span>
                <div class="d-flex fixed-format-entry-row flex-wrap">
                    <div
                        v-for="(entry, index) in entryGroup.entries"
                        :key="index"
                        class="fixed-format-entry"
                        :class="{
                            'timepoint-wrapper':
                                index == 0 ||
                                entry.timestamp !=
                                    flatFormatArray[index - 1].timestamp
                        }"
                    >
                        <component
                            :is="'div'"
                            class="fixed-entry d-flex flex-column"
                        >
                            <img
                                v-if="
                                    entry.type == 'activity' &&
                                        entry.data.acf.content.images
                                "
                                class="mb-16 mb-md-24"
                                :src="
                                    entry.data.acf.content.images[0].sizes
                                        .medium_large
                                "
                                alt=""
                            />
                            <img
                                v-if="
                                    entry.type == 'custom' && entry.data.image
                                "
                                class="mb-16 mb-md-24"
                                :src="entry.data.image.sizes.medium_large"
                                alt=""
                            />

                            <h4 v-if="entry.type == 'activity'">
                                {{ entry.data.post_title }}
                            </h4>
                            <h4 v-if="entry.type == 'custom'">
                                {{ entry.data.title }}
                            </h4>

                            <div
                                class="content"
                                v-if="entry.type == 'activity'"
                                v-html="entry.data.acf.content.description"
                            ></div>
                            <p v-if="entry.type == 'custom'">
                                {{ entry.data.description }}
                            </p>

                            <a
                                v-if="entry.type == 'activity'"
                                :href="
                                    route('nl.activity', {
                                        slug: entry.data.post_name
                                    })
                                "
                                class="btn btn-accent align-self-start mt-24"
                                >Meer info
                                <span v-html="svg('arrow-right', 'arrow-right')"
                            /></a>
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pagePart.activities-fixed-format-row",

    props: {
        activity: {
            type: Object,
            required: true
        }
    },

    computed: {
        flatFormatArray() {
            var customArray = new Array();

            this.activity.acf.content.fixed_format.time_table.forEach(
                timestamp => {
                    timestamp.Template.forEach(template => {
                        if (template.format_type == "activities") {
                            if (
                                template.time_stamp_activities != false &&
                                template.time_stamp_activities.length > 0
                            ) {
                                template.time_stamp_activities[0].activities.forEach(
                                    activity => {
                                        customArray.push({
                                            timestamp: timestamp.time_stamp,
                                            type: "activity",
                                            data: activity
                                        });
                                    }
                                );
                            }
                        }
                        if (template.format_type == "custom") {
                            if (
                                template.time_stamp_custom != false &&
                                template.time_stamp_custom.length > 0
                            ) {
                                template.time_stamp_custom.forEach(custom => {
                                    customArray.push({
                                        timestamp: timestamp.time_stamp,
                                        type: "custom",
                                        data: custom
                                    });
                                });
                            }
                        }
                    });
                }
            );

            return customArray;
        },

        groupedFlatFormatArray() {
            var groupedArray = new Array();

            this.flatFormatArray.forEach(entry => {
                if (
                    groupedArray.length == 0 ||
                    groupedArray[groupedArray.length - 1].timestamp !=
                        entry.timestamp
                ) {
                    groupedArray.push({
                        timestamp: entry.timestamp,
                        entries: new Array()
                    });
                }

                groupedArray[groupedArray.length - 1].entries.push(entry);
            });

            return groupedArray;
        }
    }
};
</script>
